import styled, { css } from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import { fadeIn } from 'builder/styles/keyframes'

export const Container = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 680px;
  max-height: 620px;
  padding-top: 48px;
  background-color: ${Colors.Neutral10};
  text-align: center;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`

export const Title = styled.div`
  ${Typography.S};
  ${FontWeights.DemiBold};
  flex-shrink: 0;

  ${Media.Phone`
    margin: 0 52px 12px;
  `}
`

export const SwiperContainer = styled.div`
  position: relative;
  &::after {
    position: absolute;
    background: linear-gradient(270deg, ${Colors.White} 0%, rgba(255, 255, 255, 0) 101.56%);
    content: ' ';
    width: 322px;
    height: 100%;
    top: 0;
    right: 0;
    z-index: 1;
    border-radius: 16px;

    ${Media.Tablet`
      display: none;
    `}

    ${Media.Phone`
      display: none;
  `}
  }
`

export const SliderContent = styled.div`
  width: 100%;
  max-width: 1120px;
  margin: 30px auto 0;
  animation: ${fadeIn} 0.3s ease;
  animation-fill-mode: forwards;
  padding-bottom: 64px;
  position: relative;

  ${Media.Laptop`
    padding: 0 15px 64px 20px;
    overflow: hidden;
  `}

  &::before {
    position: absolute;
    background: ${Colors.White};
    content: ' ';
    width: 100%;
    height: 100%;
    top: 0;
    right: 100%;
    z-index: 1;

    ${Media.Tablet`
      display: none;
    `}

    ${Media.Phone`
      display:none
    `}
  }

  ${Media.Phone`
    margin-top: 24px;
    padding-bottom: 48px;
  `}

  & .swiper-container {
    position: relative;
    overflow: visible;
  }

  & .swiper-wrapper {
    display: flex;
    position: relative;
    transition-property: transform;
  }
`

export const SliderPlaceholder = styled.div`
  height: 464px;
  width: 100%;

  ${Media.Phone`
    height: auto;
  `}
`

export const SliderContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  margin-top: 70px;
  position: relative;

  ${Media.Phone`
    margin-top: 48px;
  `}
`

interface CircleButtonOptions {
  direction?: 'left' | 'right'
  size?: number
}

export const TestimonialsButton = styled.button<CircleButtonOptions>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  width: ${props => props.size || 40}px;
  height: ${props => props.size || 40}px;
  border: none;
  border-radius: 50%;
  background-color: ${Colors.Neutral10};
  color: ${Colors.Neutral40};
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${Colors.Neutral20};
  }

  ${props =>
    props.direction === 'left' &&
    css`
      transform: rotate(180deg);
    `}

  position: absolute;
  z-index: 2;
  top: calc(50%);

  ${Media.Phone`
    display: none;
  `}
`

export const TestimonialsLeftButton = styled(TestimonialsButton).attrs({
  direction: 'right',
})`
  right: calc(50% - 50px - 12px);
  top: 0;
`

export const TestimonialsRightButton = styled(TestimonialsButton).attrs({
  direction: 'left',
})`
  left: calc(50% - 10px - 24px);
  top: 0;
`

export const NavigationButtons = styled.div`
  transform: scaleX(-1);
  width: 92px;
  height: 40px;
  position: relative;
  z-index: 10;
`

export const SectionHeading = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${Media.Laptop`
    padding: 0 20px;
  `}
`

export const HeaderText = styled.div`
  ${Typography.S};
  ${FontWeights.Medium};
  align-self: center;
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px;
  gap: 1px;
  justify-content: space-between;
  width: 363px;
  height: 420px;
  background: ${Colors.Neutral5};
  border: 1px solid ${Colors.Neutral15};
  border-radius: 16px;

  ${Media.Tablet`
    width: 348px;
  `}

  ${Media.Phone`
    width: 319px;
    height: 360px;
  `}
`

export const Testimonial = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Text = styled.div`
  ${FontWeights.Medium};
`

export const SubText = styled.div``

export const Name = styled.div`
  ${Typography.Subhead};
  ${FontWeights.Medium};
  color: ${Colors.Neutral50};
`
